<template>
  <div class="about">
    <h2>Here's the dev team</h2>

    <div class="devs" v-for="i in devs" :key=i.name>
      <md-card md-with-hover>
          <md-card-header>
            <div class="md-title">
              <h3>{{i.name}}</h3>
            </div>
            <div class="md-subhead">
              <p style = "color:gray">{{i.role}}</p>
              <a :href="`mailto:${i.email}`">{{i.email}}</a>
            </div>
          </md-card-header>
          <md-card-content>
          </md-card-content>
      </md-card>
    </div>

    <div class="github">
    <md-card>
      <md-cardheader>
        <h2>
          Visit ReceiptTracker on GitHub
        </h2>
        <div class="md-subhead">
          <a :href="'https://github.com/SCCapstone/ReceiptTracker'">Our GitHub Page</a>
        </div>
      </md-cardheader>
    </md-card>
    </div>


  </div>
</template>

<script>
export default {
  name: 'About',
  components: {},
  data() {
    return {
      devs: [
        {
          name : "Jake Bukuts",
          role : "Manager & Researcher",
          email: "jbukuts@gmail.com"
        },
        {
          name : "Deja Scott",
          role : "Repo Master & Editor",
          email: "ds17@email.sc.edu"
        },
        {
          name : "Drew Tant",
          role : "Researcher & Pessimist",
          email: "drewtant23@gmail.com"
        },
        {
          name : "Kannika Phatsavong",
          role: "Analyst & Tester",
          email: "mck.phatsavong@gmail.com"
        },
        {
          name : "Anukrithi Myadala",
          role : "Optimist & Researcher",
          email: "amyadala@email.sc.edu"
        }
      ]
    }
  }
}
</script>

<style scoped>
.about {
  width: 50%;
  margin-right: auto;
  margin-left: auto;
  text-align: center;
}

/*
.devs{
  display: inline-block;
  text-align: center;
  padding-right: 3px;
  padding-left: 3px;
  position: relative;
}
*/
.devs{
  display: inline-block;
  margin: 15px;
  padding: 20px;

  position: relative;

  border-radius: 18px;
  background:rgb(255, 255, 255);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);

  text-align: center;
  color: rgb(59, 58, 58);
  transition: all 0.15s ease;
  cursor: pointer;
}
.devs:hover {
  transform: scale(1.2);
  box-shadow: 5px 5px 15px rgba(0,0,0,0,6);

}

.github{
  padding-top: 4%;
}

a:hover{
  text-decoration: underline;
}

a {
  text-decoration: none;
  color: rgb(9, 110, 26);
}

</style>
